// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// cc-common imports
import { IconConstants, Utils } from 'cc-common';

// service imports
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';
import { ProjectTaskService } from '../../_services/project-task.service';

// model imports
import { ProjectTaskItemResultDto } from '../../_models/project-task-item-result-dto';
import { ProjectTaskViewerParameterDto } from '../../_models/project-task-viewer-parameter-dto';

// constant imports
import { StringFormatConstants } from '../../../_constants/string-format-constants';

@Component({
    selector: 'app-project-task-viewer',
    templateUrl: './project-task-viewer.component.html',
    styleUrls: ['./project-task-viewer.component.scss']
})
export class ProjectTaskViewerComponent implements OnInit {
    @ViewChild('taskViewerPopup', { static: false }) taskViewerPopup: DxPopupComponent;

    @Input() taskId: number;
    @Input() communityId: number;
    @Input() popupWidth = '35';
    @Input() popupHeight = '40';
    @Input() notesActionCode: string = null;

    @Output() onClose = new EventEmitter<void>();

    width: string;
    height: string;

    visible = false;
    title: string;

    projectTaskInfo: ProjectTaskItemResultDto;

    dateFormat: string;

    showNotesEditor = false;

    iconClose = IconConstants.CLOSE;
    iconNotes = IconConstants.NOTES_AVAILABLE;
    iconEmptyNotes = IconConstants.NOTES_EMPTY;

    constructor(
        private readonly projectTaskService: ProjectTaskService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.width = `${this.popupWidth}%`;
        this.height = `${this.popupHeight}%`;
        this.dateFormat = StringFormatConstants.dateFormat;
        this.show();
    }

    show(): void {
        this.visible = true;
        this.title = `View Project Task # ${this.taskId}`;
    }

    onTaskViewerShown(): void {
        this.taskViewerPopup.instance.repaint();
        this.loadProjectTaskViewer(true);
    }

    onTaskViewerClose(): void {
        this.closeViewer();
    }

    onNotesClick(): void {
        this.showNotesEditor = true;
    }

    onNotesEditorClose(forceReload: boolean): void {
        this.showNotesEditor = false;
        if (Utils.isTrue(forceReload)) {
            this.loadProjectTaskViewer(true);
        }
    }

    private loadProjectTaskViewer(clearCache = false): void {
        const baseParams: ProjectTaskViewerParameterDto = new ProjectTaskViewerParameterDto();
        baseParams.projectTaskId = this.taskId;
        baseParams.communityId = this.communityId;
        baseParams.clearCache = clearCache;

        this.projectTaskService.getProjectTaskDetails(baseParams).subscribe(
            (result: ProjectTaskItemResultDto) => {
                this.projectTaskInfo = result;
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private closeViewer(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
